<template>
  <div class="flex flex-col text-center justify-center items-center p-4">
    <slot />
    <a
      :href="portalLoginLink"
      v-if="showPortalLoginLink"
      class="mt-3 flex items-center focus:ring-4 border font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none text-white border-primary-600 hover:border-primary-600 bg-primary-600 hover:bg-primary-500 focus:ring-primary-300"
    >
      Access your portal
    </a>
  </div>
</template>
<script>
export default {
  name: "PortalBillingPaymentMethodSuccess",
  computed: {
    showPortalLoginLink() {
      return window.FinancialCents.company.hasOwnProperty("firm_custom_uri")
    },

    portalLoginLink() {
      let customUri = window.FinancialCents.company.firm_custom_uri
      return customUri
        ? `${window.location.origin}/cp/${window.FinancialCents.company.firm_custom_uri}`
        : `${window.location.origin}/cp`
    },
  },
}
</script>
